import { createFileRoute } from '@tanstack/react-router';
import { RequestResetPasswordPage } from '@/pages/request-reset-password';

export const Route = createFileRoute('/reset-password')({
  component: RequestResetPasswordPage,
});
